export default [
  {
    id: 444,
    object: "kanji",
    url: "https://api.wanikani.com/v2/subjects/444",
    data_updated_at: "2019-12-31T06:03:54.692938Z",
    data: {
      created_at: "2012-02-27T22:41:23.000000Z",
      level: 1,
      slug: "人",
      hidden_at: null,
      document_url: "https://www.wanikani.com/kanji/%E4%BA%BA",
      characters: "人",
      meanings: [{ meaning: "Person", primary: true, accepted_answer: true }],
      auxiliary_meanings: [],
      readings: [
        {
          type: "onyomi",
          primary: true,
          reading: "にん",
          accepted_answer: true,
        },
        {
          type: "onyomi",
          primary: true,
          reading: "じん",
          accepted_answer: true,
        },
        {
          type: "kunyomi",
          primary: false,
          reading: "ひと",
          accepted_answer: false,
        },
        {
          type: "kunyomi",
          primary: false,
          reading: "と",
          accepted_answer: false,
        },
      ],
      component_subject_ids: [9],
      amalgamation_subject_ids: [
        2475,
        2476,
        2477,
        2478,
        2479,
        2488,
        2502,
        2582,
        2604,
        2632,
        2655,
        2674,
        2691,
        2715,
        2719,
        2782,
        2887,
        2989,
        2995,
        3014,
        3061,
        3069,
        3141,
        3202,
        3232,
        3254,
        3264,
        3356,
        3358,
        3402,
        3407,
        3412,
        3420,
        3452,
        3540,
        3606,
        3621,
        3677,
        3699,
        3708,
        3724,
        3748,
        3793,
        3862,
        3898,
        3899,
        3907,
        3936,
        4130,
        4153,
        4158,
        4203,
        4257,
        4305,
        4344,
        4365,
        4385,
        4433,
        4909,
        4964,
        4982,
        4985,
        5014,
        5144,
        5224,
        5474,
        5510,
        5524,
        5733,
        6029,
        6154,
        6209,
        6260,
        6283,
        6450,
        6613,
        6870,
        7218,
        7462,
        7465,
        7517,
        7560,
        7757,
        7783,
        8005,
        8255,
        8384,
        8551,
        8604,
        8659,
        8735,
        8805,
      ],
      visually_similar_subject_ids: [445],
      meaning_mnemonic:
        "Remember how the radical version of this kanji meant <radical>person</radical> because it's a person walking from the side with their arms down? Well this is a <kanji>person</kanji> too!",
      meaning_hint: "Know the radicals, and you shall know the kanji.",
      reading_mnemonic:
        "Only one <kanji>person</kanji> at <reading>Nintendo</reading> (<ja>にん</ja>) complained about the new <reading>Jeans</reading> (<ja>じん</ja>) policy, and that person was you.",
      reading_hint:
        "Imagine how angry you were about the policy. You'll have to come up with something to be angry about yourself (pick something that would actually make you angry, like maybe you're only allowed to wear cut off short-shorts jeans at Nintendo now), but if you pick something good, you'll definitely remember the two readings for this. Just remember you're working at <reading>Nintendo</reading>, and the policy has to be something about <reading>jeans</reading>. Then, imagine yourself as the only <kanji>person</kanji> complaining and everyone else in their dumb jeans (or lack-thereof) shaking their head at you because you're being a fool.",
      lesson_position: 30,
    },
  },
  {
    id: 453,
    object: "kanji",
    url: "https://api.wanikani.com/v2/subjects/453",
    data_updated_at: "2020-04-03T18:44:05.409868Z",
    data: {
      created_at: "2012-02-28T01:54:53.000000Z",
      level: 1,
      slug: "大",
      hidden_at: null,
      document_url: "https://www.wanikani.com/kanji/%E5%A4%A7",
      characters: "大",
      meanings: [
        { meaning: "Big", primary: true, accepted_answer: true },
        { meaning: "Large", primary: false, accepted_answer: true },
      ],
      auxiliary_meanings: [],
      readings: [
        {
          type: "onyomi",
          primary: true,
          reading: "たい",
          accepted_answer: true,
        },
        {
          type: "onyomi",
          primary: true,
          reading: "だい",
          accepted_answer: true,
        },
        {
          type: "kunyomi",
          primary: false,
          reading: "おお",
          accepted_answer: false,
        },
        {
          type: "nanori",
          primary: false,
          reading: "ひろ",
          accepted_answer: false,
        },
      ],
      component_subject_ids: [18],
      amalgamation_subject_ids: [
        2499,
        2500,
        2501,
        2502,
        2602,
        2661,
        2741,
        2792,
        2812,
        2815,
        3001,
        3016,
        3085,
        3332,
        3436,
        3581,
        3731,
        3751,
        3918,
        3952,
        4052,
        4129,
        4206,
        4249,
        4405,
        4525,
        4536,
        4727,
        4842,
        4868,
        4987,
        5013,
        5045,
        5193,
        5202,
        5259,
        5274,
        5424,
        5425,
        5481,
        5518,
        5642,
        5823,
        5961,
        6085,
        6822,
        7035,
        7077,
        7151,
        7224,
        7304,
        7416,
        7528,
        7609,
        7676,
        7784,
        7915,
        7974,
        8270,
        8401,
        8559,
        8574,
        8576,
        8659,
        8661,
        8666,
        8668,
        8694,
      ],
      visually_similar_subject_ids: [505, 481],
      meaning_mnemonic:
        "The <radical>big</radical> radical and the <kanji>big</kanji> kanji are exactly the same!",
      meaning_hint:
        "So, if you know the radical, you know the meaning of this kanji as well.",
      reading_mnemonic:
        "There's this big guy (that's how you remember the radical, remember?), and he's wearing a huge <reading>Tie Dye</reading> (<ja>たい</ja>, <ja>だい</ja>) shirt. Because he's so huge, the tie dye shirt is also super huge. Everything about him is pretty big, but the tie dye stands out more than anything.",
      reading_hint:
        "When you look at the big guy in your head, imagine him covered in tie dye head to toe. Think about how ridiculous it looks on him, especially since he's such a big guy. Shirt. Sweatpants. Hat. Shoes... it goes on and on.",
      lesson_position: 40,
    },
  },
  {
    id: 455,
    object: "kanji",
    url: "https://api.wanikani.com/v2/subjects/455",
    data_updated_at: "2019-12-31T06:03:55.007128Z",
    data: {
      created_at: "2012-02-28T01:57:19.000000Z",
      level: 1,
      slug: "山",
      hidden_at: null,
      document_url: "https://www.wanikani.com/kanji/%E5%B1%B1",
      characters: "山",
      meanings: [{ meaning: "Mountain", primary: true, accepted_answer: true }],
      auxiliary_meanings: [],
      readings: [
        {
          type: "onyomi",
          primary: true,
          reading: "さん",
          accepted_answer: true,
        },
        {
          type: "kunyomi",
          primary: false,
          reading: "やま",
          accepted_answer: false,
        },
      ],
      component_subject_ids: [20],
      amalgamation_subject_ids: [
        2504,
        2505,
        2549,
        3392,
        3652,
        4440,
        5475,
        5490,
        5923,
        5925,
        6534,
        6708,
        7858,
        8140,
        8233,
        8410,
        8678,
      ],
      visually_similar_subject_ids: [1720],
      meaning_mnemonic:
        "The <radical>mountain</radical> radical and the <kanji>mountain</kanji> kanji are the same.",
      meaning_hint:
        "Make sure you're studying your radicals. If you are, then you're studying your kanji as well!",
      reading_mnemonic:
        'Think about <kanji>mountains</kanji> talking to each other, calling each other by their names and adding the Japanese name-ender <reading>san</reading> (<ja>さん</ja>) to each of their names. "Hello, Everest-<reading>san</reading>." "Oh hi, Fuji-<reading>san</reading>."',
      reading_hint:
        "Be sure to imagine this vividly. The more absurdly you can imagine it, the more likely you are to remember the reading, <reading>san</reading>.",
      lesson_position: 42,
    },
  },
  {
    id: 2502,
    object: "vocabulary",
    url: "https://api.wanikani.com/v2/subjects/2502",
    data_updated_at: "2019-12-31T06:04:52.956381Z",
    data: {
      created_at: "2012-02-28T08:19:56.000000Z",
      level: 1,
      slug: "大人",
      hidden_at: null,
      document_url: "https://www.wanikani.com/vocabulary/%E5%A4%A7%E4%BA%BA",
      characters: "大人",
      meanings: [{ meaning: "Adult", primary: true, accepted_answer: true }],
      auxiliary_meanings: [],
      readings: [{ primary: true, reading: "おとな", accepted_answer: true }],
      parts_of_speech: ["noun"],
      component_subject_ids: [453, 444],
      meaning_mnemonic:
        "This kanji combines <kanji>big</kanji> and <kanji>person</kanji>. If you're a child, how do you think of adults? You just think of them like big people. That's why this combination of kanji means <vocabulary>adult</vocabulary>.",
      reading_mnemonic:
        '"I\'m an <kanji>adult</kanji>, which means I have adult responsibilities. <reading>Oh, Toner</reading> (<ja>おとな</ja>)? I need some of that for my terrible printer..." ... now feel so sad you have such a terrible printer that runs out of toner every day. Ohhhh Toner!',
      context_sentences: [
        {
          en: "This is the adult price.",
          ja: "これは、大人のりょうきんです。",
        },
        { en: "There are only three adults.", ja: "大人は三人だけです。" },
        {
          en: "The adults went to an izakaya.",
          ja: "大人たちはいざかやにいった。",
        },
      ],
      pronunciation_audios: [
        {
          url:
            "https://cdn.wanikani.com/audios/27928-subject-2502.mp3?1553788652",
          metadata: {
            gender: "female",
            source_id: 21614,
            pronunciation: "おとな",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/27926-subject-2502.ogg?1553788651",
          metadata: {
            gender: "female",
            source_id: 21614,
            pronunciation: "おとな",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/2819-subject-2502.ogg?1547862309",
          metadata: {
            gender: "male",
            source_id: 2696,
            pronunciation: "おとな",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/2816-subject-2502.mp3?1547862309",
          metadata: {
            gender: "male",
            source_id: 2696,
            pronunciation: "おとな",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
      ],
      lesson_position: 77,
    },
  },
  {
    id: 2503,
    object: "vocabulary",
    url: "https://api.wanikani.com/v2/subjects/2503",
    data_updated_at: "2020-03-27T20:25:55.704139Z",
    data: {
      created_at: "2012-02-28T08:20:08.000000Z",
      level: 1,
      slug: "女",
      hidden_at: null,
      document_url: "https://www.wanikani.com/vocabulary/%E5%A5%B3",
      characters: "女",
      meanings: [
        { meaning: "Woman", primary: true, accepted_answer: true },
        { meaning: "Female", primary: false, accepted_answer: true },
      ],
      auxiliary_meanings: [],
      readings: [{ primary: true, reading: "おんな", accepted_answer: true }],
      parts_of_speech: ["noun"],
      component_subject_ids: [454],
      meaning_mnemonic:
        "When a kanji is alone and doesn't have any okurigana (hiragana attached to the kanji) it's usually going to take the same meaning as the kanji it comes from. So in this case, you know that this word means <vocabulary>woman</vocabulary>.",
      reading_mnemonic:
        "When a word is a single kanji with no okurigana (hiragana attached to the kanji) it tends to use a kun'yomi reading. You didn't learn the kun'yomi reading when you learned the kanji itself, so let's use a mnemonic to remember the vocab word.\r\n\r\nThere's a woman in front of you. Who is she? She's the woman who lives <reading>on Ni</reading> (おんな)nth Street! ",
      context_sentences: [
        { en: "Who is that woman?", ja: "あの女はだれ？" },
        { en: "I'm a woman.", ja: "わたしは女です。" },
        {
          en: "I want a woman who will help look after my children.",
          ja: "おれはこどもをせわする女がほしい。",
        },
      ],
      pronunciation_audios: [
        {
          url:
            "https://cdn.wanikani.com/audios/27978-subject-2503.ogg?1553788711",
          metadata: {
            gender: "female",
            source_id: 21639,
            pronunciation: "おんな",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/27974-subject-2503.mp3?1553788710",
          metadata: {
            gender: "female",
            source_id: 21639,
            pronunciation: "おんな",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/3117-subject-2503.ogg?1547862379",
          metadata: {
            gender: "male",
            source_id: 2722,
            pronunciation: "おんな",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/3115-subject-2503.mp3?1547862378",
          metadata: {
            gender: "male",
            source_id: 2722,
            pronunciation: "おんな",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
      ],
      lesson_position: 78,
    },
  },
  {
    id: 2504,
    object: "vocabulary",
    url: "https://api.wanikani.com/v2/subjects/2504",
    data_updated_at: "2019-12-31T06:04:53.009109Z",
    data: {
      created_at: "2012-02-28T08:20:18.000000Z",
      level: 1,
      slug: "山",
      hidden_at: null,
      document_url: "https://www.wanikani.com/vocabulary/%E5%B1%B1",
      characters: "山",
      meanings: [{ meaning: "Mountain", primary: true, accepted_answer: true }],
      auxiliary_meanings: [],
      readings: [{ primary: true, reading: "やま", accepted_answer: true }],
      parts_of_speech: ["noun"],
      component_subject_ids: [455],
      meaning_mnemonic:
        "A vocab made of a single kanji all alone with no okurigana (hiragana attached to the kanji) usually has the same exact meaning as the kanji it's made from. So by that you know that this vocab's meaning is <vocabulary>mountain</vocabulary>.",
      reading_mnemonic:
        "When a vocab is a single kanji all alone with no okurigana (hiragana attached to the kanji) it's usually going to be the kun'yomi reading, which you didn't learn when you learned the kanji. To remember this word's reading we'll use a mnemonic.\r\n\r\nWhat are you doing going up into the <vocabulary>mountain</vocabulary>s? You're hunting for <reading>yam</reading>s (<ja>やま</ja>). Go ahead, imagine yourself doing just that, climbing up the mountain (it's hard work!) and then digging in the ground with your hands, then pulling up that sweet, delicious yam! Mmm!",
      context_sentences: [
        {
          en: "I'll climb a mountain with my friends.",
          ja: "ともだちといっしょに、山にのぼります。",
        },
        {
          en: "This is the world's biggest man-made mountain.",
          ja: "これはせかい一大きい人工の山なんですよ。",
        },
        {
          en: "At 8 am, let’s meet naked on Bald Mountain.",
          ja: "あさ八じに、はだかではげ山にしゅうごうしましょう。",
        },
      ],
      pronunciation_audios: [
        {
          url:
            "https://cdn.wanikani.com/audios/27957-subject-2504.mp3?1553788692",
          metadata: {
            gender: "female",
            source_id: 21629,
            pronunciation: "やま",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/27956-subject-2504.ogg?1553788692",
          metadata: {
            gender: "female",
            source_id: 21629,
            pronunciation: "やま",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/2988-subject-2504.ogg?1547862349",
          metadata: {
            gender: "male",
            source_id: 2710,
            pronunciation: "やま",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/2984-subject-2504.mp3?1547862348",
          metadata: {
            gender: "male",
            source_id: 2710,
            pronunciation: "やま",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
      ],
      lesson_position: 79,
    },
  },
  {
    id: 7560,
    object: "vocabulary",
    url: "https://api.wanikani.com/v2/subjects/7560",
    data_updated_at: "2019-12-31T06:07:39.892902Z",
    data: {
      created_at: "2015-02-25T22:23:17.972924Z",
      level: 1,
      slug: "人工",
      hidden_at: null,
      document_url: "https://www.wanikani.com/vocabulary/%E4%BA%BA%E5%B7%A5",
      characters: "人工",
      meanings: [
        { meaning: "Artificial", primary: true, accepted_answer: true },
        { meaning: "Man Made", primary: false, accepted_answer: true },
        { meaning: "Human Made", primary: false, accepted_answer: true },
      ],
      auxiliary_meanings: [],
      readings: [{ primary: true, reading: "じんこう", accepted_answer: true }],
      parts_of_speech: ["noun", "の adjective"],
      component_subject_ids: [444, 457],
      meaning_mnemonic:
        "A <kanji>person</kanji> of <kanji>industry</kanji> makes a lot of things by hand, so everything they make is <vocabulary>artificial</vocabulary>, and also means it's <vocabulary>man made</vocabulary>.",
      reading_mnemonic:
        "This is a jukugo word that uses the on'yomi readings of the kanji. You should be able to read this on your own.",
      context_sentences: [
        {
          en: "Is your brain really artificial?",
          ja: "あなたののうは、ほんとうに人工ののうなんですか？",
        },
        { en: "This river is man-made.", ja: "この川は、人工の川です。" },
        {
          en: "I put artificial turf in the garden.",
          ja: "にわに人工しばをしいてみました。",
        },
      ],
      pronunciation_audios: [
        {
          url:
            "https://cdn.wanikani.com/audios/27935-subject-7560.mp3?1553788662",
          metadata: {
            gender: "female",
            source_id: 21618,
            pronunciation: "じんこう",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/27934-subject-7560.ogg?1553788661",
          metadata: {
            gender: "female",
            source_id: 21618,
            pronunciation: "じんこう",
            voice_actor_id: 1,
            voice_actor_name: "Kyoko",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/2869-subject-7560.mp3?1547862320",
          metadata: {
            gender: "male",
            source_id: 2700,
            pronunciation: "じんこう",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/mpeg",
        },
        {
          url:
            "https://cdn.wanikani.com/audios/2866-subject-7560.ogg?1547862319",
          metadata: {
            gender: "male",
            source_id: 2700,
            pronunciation: "じんこう",
            voice_actor_id: 2,
            voice_actor_name: "Kenichi",
            voice_description: "Tokyo accent",
          },
          content_type: "audio/ogg",
        },
      ],
      lesson_position: 83,
    },
  },
  {
    id: 8761,
    object: "radical",
    url: "https://api.wanikani.com/v2/subjects/8761",
    data_updated_at: "2020-03-04T16:06:47.888073Z",
    data: {
      created_at: "2012-02-27T18:34:03.000000Z",
      level: 1,
      slug: "stick",
      hidden_at: null,
      document_url: "https://www.wanikani.com/radicals/stick",
      characters: null,
      character_images: [
        {
          url:
            "https://cdn.wanikani.com/images/110-subject-8761-with-css-original.svg?1520987081",
          metadata: { inline_styles: true },
          content_type: "image/svg+xml",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1066-subject-8761-normal-weight-black-original.png?1520987638",
          metadata: {
            color: "#000000",
            dimensions: "1024x1024",
            style_name: "original",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1066-subject-8761-normal-weight-black-1024px.png?1520987638",
          metadata: {
            color: "#000000",
            dimensions: "1024x1024",
            style_name: "1024px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1066-subject-8761-normal-weight-black-512px.png?1520987638",
          metadata: {
            color: "#000000",
            dimensions: "512x512",
            style_name: "512px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1066-subject-8761-normal-weight-black-256px.png?1520987638",
          metadata: {
            color: "#000000",
            dimensions: "256x256",
            style_name: "256px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1066-subject-8761-normal-weight-black-128px.png?1520987638",
          metadata: {
            color: "#000000",
            dimensions: "128x128",
            style_name: "128px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1066-subject-8761-normal-weight-black-64px.png?1520987638",
          metadata: {
            color: "#000000",
            dimensions: "64x64",
            style_name: "64px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1066-subject-8761-normal-weight-black-32px.png?1520987638",
          metadata: {
            color: "#000000",
            dimensions: "32x32",
            style_name: "32px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/588-subject-8761-without-css-original.svg?1520987231",
          metadata: { inline_styles: false },
          content_type: "image/svg+xml",
        },
      ],
      meanings: [{ meaning: "Stick", primary: true, accepted_answer: true }],
      auxiliary_meanings: [],
      amalgamation_subject_ids: [
        507,
        586,
        588,
        990,
        1107,
        1262,
        1349,
        1360,
        1611,
        2238,
        2256,
        2343,
        8862,
      ],
      meaning_mnemonic:
        "This is a <radical>stick</radical>, sticking out of the ground. It even looks like a stick.",
      lesson_position: 25,
    },
  },
  {
    id: 8762,
    object: "radical",
    url: "https://api.wanikani.com/v2/subjects/8762",
    data_updated_at: "2019-12-31T06:08:16.405338Z",
    data: {
      created_at: "2012-02-27T18:34:58.000000Z",
      level: 1,
      slug: "gun",
      hidden_at: null,
      document_url: "https://www.wanikani.com/radicals/gun",
      characters: null,
      character_images: [
        {
          url:
            "https://cdn.wanikani.com/images/1055-subject-8762-normal-weight-black-original.png?1520987608",
          metadata: {
            color: "#000000",
            dimensions: "1024x1024",
            style_name: "original",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1055-subject-8762-normal-weight-black-1024px.png?1520987608",
          metadata: {
            color: "#000000",
            dimensions: "1024x1024",
            style_name: "1024px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1055-subject-8762-normal-weight-black-512px.png?1520987608",
          metadata: {
            color: "#000000",
            dimensions: "512x512",
            style_name: "512px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1055-subject-8762-normal-weight-black-256px.png?1520987608",
          metadata: {
            color: "#000000",
            dimensions: "256x256",
            style_name: "256px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1055-subject-8762-normal-weight-black-128px.png?1520987608",
          metadata: {
            color: "#000000",
            dimensions: "128x128",
            style_name: "128px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1055-subject-8762-normal-weight-black-64px.png?1520987608",
          metadata: {
            color: "#000000",
            dimensions: "64x64",
            style_name: "64px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1055-subject-8762-normal-weight-black-32px.png?1520987608",
          metadata: {
            color: "#000000",
            dimensions: "32x32",
            style_name: "32px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/99-subject-8762-with-css-original.svg?1520987072",
          metadata: { inline_styles: true },
          content_type: "image/svg+xml",
        },
        {
          url:
            "https://cdn.wanikani.com/images/577-subject-8762-without-css-original.svg?1520987228",
          metadata: { inline_styles: false },
          content_type: "image/svg+xml",
        },
      ],
      meanings: [{ meaning: "Gun", primary: true, accepted_answer: true }],
      auxiliary_meanings: [],
      amalgamation_subject_ids: [
        546,
        572,
        640,
        816,
        830,
        1002,
        1007,
        1210,
        1379,
        1381,
        1417,
        1418,
        1428,
        1438,
        1499,
        1667,
        1698,
        1728,
        2280,
        2332,
      ],
      meaning_mnemonic:
        "Doesn't this look like a long <radical>gun</radical>? You have a shoulder rest and the barrel. Bam bam bam! Imagine looking down its long barrel at a target. Feel the rest on your shoulder. Now that's a nice gun!",
      lesson_position: 22,
    },
  },
  {
    id: 8763,
    object: "radical",
    url: "https://api.wanikani.com/v2/subjects/8763",
    data_updated_at: "2019-12-31T06:08:16.432311Z",
    data: {
      created_at: "2012-02-27T18:35:58.000000Z",
      level: 1,
      slug: "leaf",
      hidden_at: null,
      document_url: "https://www.wanikani.com/radicals/leaf",
      characters: null,
      character_images: [
        {
          url:
            "https://cdn.wanikani.com/images/1056-subject-8763-normal-weight-black-original.png?1520987610",
          metadata: {
            color: "#000000",
            dimensions: "1024x1024",
            style_name: "original",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1056-subject-8763-normal-weight-black-1024px.png?1520987610",
          metadata: {
            color: "#000000",
            dimensions: "1024x1024",
            style_name: "1024px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1056-subject-8763-normal-weight-black-512px.png?1520987610",
          metadata: {
            color: "#000000",
            dimensions: "512x512",
            style_name: "512px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1056-subject-8763-normal-weight-black-256px.png?1520987610",
          metadata: {
            color: "#000000",
            dimensions: "256x256",
            style_name: "256px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1056-subject-8763-normal-weight-black-128px.png?1520987610",
          metadata: {
            color: "#000000",
            dimensions: "128x128",
            style_name: "128px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1056-subject-8763-normal-weight-black-64px.png?1520987610",
          metadata: {
            color: "#000000",
            dimensions: "64x64",
            style_name: "64px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/1056-subject-8763-normal-weight-black-32px.png?1520987610",
          metadata: {
            color: "#000000",
            dimensions: "32x32",
            style_name: "32px",
          },
          content_type: "image/png",
        },
        {
          url:
            "https://cdn.wanikani.com/images/578-subject-8763-without-css-original.svg?1520987228",
          metadata: { inline_styles: false },
          content_type: "image/svg+xml",
        },
        {
          url:
            "https://cdn.wanikani.com/images/100-subject-8763-with-css-original.svg?1520987074",
          metadata: { inline_styles: true },
          content_type: "image/svg+xml",
        },
      ],
      meanings: [{ meaning: "Leaf", primary: true, accepted_answer: true }],
      auxiliary_meanings: [],
      amalgamation_subject_ids: [495, 549, 629, 659, 1196, 1310, 1423],
      meaning_mnemonic:
        "There's a leaf on top and a stem going down out of it, making it the <radical>leaf</radical> radical. It looks kind of like a lilypad, sitting on top of the water with its stem going down to the bottom where the dirt is.",
      lesson_position: 21,
    },
  },
];
